import { createFileRoute, redirect } from "@tanstack/react-router";

/** The watchdog moved onto the models page (SP-025); old links land there. */
export const Route = createFileRoute("/app/admin/watchdog")({
  beforeLoad: () => {
    throw redirect({ to: "/app/admin/models" });
  },
});
